// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiple-reports-list .row div[class^=col-]:empty {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/User/Reports/UserMultipleReportsListView/UserMultipleReportsListView.scss"],"names":[],"mappings":"AAEI;EACE,aAAA;AADN","sourcesContent":[".multiple-reports-list {\n  .row {\n    div[class^='col-']:empty {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
